import { Twitter, Instagram, Facebook, Youtube } from "lucide-react";
import { useSocials } from "@/components/Logo";

const DEFAULT_SOCIALS = {
  x: "https://x.com/sportsgeardfw",
  instagram: "https://instagram.com/sportsgeardfw",
  facebook: "https://facebook.com/sportsgeardfw",
  youtube: "https://youtube.com/@sportsgeardfw",
  tiktok: "https://tiktok.com/@sportsgeardfw",
};

function TikTokIcon({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.05-.1z" />
    </svg>
  );
}

const PLATFORMS = [
  ["x", "X (Twitter)", Twitter],
  ["instagram", "Instagram", Instagram],
  ["facebook", "Facebook", Facebook],
  ["youtube", "YouTube", Youtube],
  ["tiktok", "TikTok", TikTokIcon],
];

export function SocialLinks({ className = "" }) {
  const saved = useSocials();
  const links = { ...DEFAULT_SOCIALS, ...saved };
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="social-links">
      {PLATFORMS.map(([key, label, Icon]) =>
        links[key] ? (
          <a
            key={key}
            href={links[key]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`SportsGearDFW on ${label}`}
            data-testid={`social-${key}`}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-bline text-slate-400 transition-all duration-200 hover:-translate-y-0.5 hover:border-volt hover:text-volt"
          >
            <Icon className="h-4 w-4" />
          </a>
        ) : null
      )}
    </div>
  );
}

export default SocialLinks;
